import { render, staticRenderFns } from "./CadFaq.vue?vue&type=template&id=0b634fa1&"
import script from "./CadFaq.vue?vue&type=script&lang=js&"
export * from "./CadFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports